
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiChartSimplifiedSymbolsIec as ObiChartSimplifiedSymbolsIecElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-chart-simplified-symbols-iec.js';
 
 
 

 
 export const ObiChartSimplifiedSymbolsIec = createComponent({
   react: React,
   tagName: 'obi-chart-simplified-symbols-iec',
   elementClass: ObiChartSimplifiedSymbolsIecElement,
   events: {
     
   }
  });
 
 